export const ResizableStyles = {
  resizableX: {
    display: 'flex',
    overflow: 'hidden',
    height: '100%',
  },
  resizableY: {
    display: 'flex',
    flexDirection: 'column',
  },
  resizerX: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: '#222029',
    padding: '1px',
    zIndex: 2,
    cursor: 'col-resize',
    "&:after": {
      content: '""',
      width: '1px',
      height: '16px',
      margin: '1px',
      background: 'lightgray',
    }
  },
  resizerY: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: '#222029',
    padding: '1px',
    zIndex: 1,
    cursor: 'row-resize',
    flexDirection: 'column',
    "&:after": {
      content: '""',
      width: '16px',
      height: '1px',
      margin: '1px',
      background: 'lightgray',
    }
  },
};

// horizontal direction
export const resizableX = () => {
  const resizer = document.querySelector('.resizerX');

  const onmousedown = (e) => {
    e.preventDefault();
    window.addEventListener("mousemove", onmousemove);
    window.addEventListener("mouseup", onmouseup);
  };

  const onmousemove = (e) => {
    e.preventDefault();
    const clientX = e.clientX;
    const deltaX = clientX - (resizer._clientX || clientX);
    resizer._clientX = clientX;
    const l = resizer.previousElementSibling;
    const r = resizer.nextElementSibling;
  
    // Minimum width constraint
    const minWidth = 200; // You can adjust this value according to your requirements
  
    // LEFT
    if (deltaX < 0) {
      const lWidth = parseInt(getComputedStyle(l).width);
      //const rWidth = parseInt(getComputedStyle(r).width);
      const newLWidth = Math.max(lWidth + deltaX, minWidth);
      //const newRWidth = rWidth - (newLWidth - lWidth);
      l.style.flex = `0 0 ${newLWidth}px`;
      //r.style.flex = `0 0 ${newRWidth}px`;
    }
    // RIGHT
    if (deltaX > 0) {
      const lWidth = parseInt(getComputedStyle(l).width);
      const rWidth = parseInt(getComputedStyle(r).width);
      const newRWidth = Math.max(rWidth - deltaX, minWidth);
      const newLWidth = lWidth - (newRWidth - rWidth);
      l.style.flex = `0 0 ${newLWidth}px`;
      //r.style.flex = `0 0 ${newRWidth}px`;
    }
  };

  const onmouseup = (e) => {
    e.preventDefault();
    window.removeEventListener("mousemove", onmousemove);
    window.removeEventListener("mouseup", onmouseup);
    delete resizer._clientX;
  };

  resizer.addEventListener("mousedown", onmousedown);
};


// vertical direction
export const resizableY = () => {
  const resizer = document.querySelector(".resizerY");
  if (!resizer) return;

  function onmousedown(e) {
    e.preventDefault();
    window.addEventListener("mousemove", onmousemove);
    window.addEventListener("mouseup", onmouseup);
  }

  function onmousemove(e) {
    e.preventDefault();
    const clientY = e.clientY;
    const deltaY = clientY - (resizer._clientY || clientY);
    resizer._clientY = clientY;
    const t = resizer.previousElementSibling;
    const b = resizer.nextElementSibling;

    if (!t || !b) return;

    // Minimum height constraint
    const minHeight = 30;
    const containerHeight = t.parentElement.offsetHeight;
    const maxHeight = containerHeight - minHeight;

    // Get current heights
    const tHeight = t.offsetHeight;
    const bHeight = b.offsetHeight;

    // Calculate new heights
    let newTHeight = tHeight;
    let newBHeight = bHeight;

    if (deltaY > 0) {
      // Moving down
      newTHeight = Math.min(maxHeight, tHeight + deltaY);
      newBHeight = Math.max(minHeight, containerHeight - newTHeight - resizer.offsetHeight);
    } else {
      // Moving up
      newTHeight = Math.max(minHeight, tHeight + deltaY);
      newBHeight = Math.min(maxHeight, containerHeight - newTHeight - resizer.offsetHeight);
    }

    // Apply new heights using flex-basis for smoother resizing
    t.style.flex = `1 0 ${newTHeight}px`;
    b.style.flex = `1 0 ${newBHeight}px`;
  }

  function onmouseup(e) {
    e.preventDefault();
    window.removeEventListener("mousemove", onmousemove);
    window.removeEventListener("mouseup", onmouseup);
    delete resizer._clientY;
  }

  resizer.addEventListener("mousedown", onmousedown);
};

// horizontal direction if one parent and multiple children with resize
export const resizableXParent = () => {
  const parentContainer = document.getElementById("parentContainer");

  if (!parentContainer) return;

  const resizers = parentContainer.querySelectorAll(".resizerX");

  resizers.forEach((resizer) => {
    resizer.addEventListener("mousedown", (e) => {
      e.preventDefault();
      const startX = e.clientX;
      resizer._clientX = startX;

      const l = resizer.previousElementSibling;
      const r = resizer.nextElementSibling;

      if (!l || !r) return;

      const minWidth = 100;

      const onmousemove = (e) => {
        e.preventDefault();
        const clientX = e.clientX;
        const deltaX = clientX - resizer._clientX;
        resizer._clientX = clientX;

        const lWidth = parseInt(getComputedStyle(l).width);
        const rWidth = parseInt(getComputedStyle(r).width);

        if (deltaX < 0) {
          const newLWidth = Math.max(lWidth + deltaX, minWidth);
          const newRWidth = rWidth - (newLWidth - lWidth);
          if (newRWidth < minWidth) return;
          l.style.flex = `0 0 ${newLWidth}px`;
          r.style.flex = `0 0 ${newRWidth}px`;
        } else if (deltaX > 0) {
          const newRWidth = Math.max(rWidth - deltaX, minWidth);
          const newLWidth = lWidth + (rWidth - newRWidth);
          if (newLWidth < minWidth) return;
          l.style.flex = `0 0 ${newLWidth}px`;
          r.style.flex = `0 0 ${newRWidth}px`;
        }
      };

      const onmouseup = () => {
        window.removeEventListener("mousemove", onmousemove);
        window.removeEventListener("mouseup", onmouseup);
        resizer._clientX = null;
      };

      window.addEventListener("mousemove", onmousemove);
      window.addEventListener("mouseup", onmouseup);
    });
  });
};



// vertical direction if one parent and multiple children with resize
export const resizableYParent = () => { //not tested
  const parentContainer = document.getElementById("parentContainer");

  parentContainer.addEventListener("mousedown", onmousedown);

  function onmousedown(e) {
    // Check if the mousedown event was triggered by a resizer element
    if (e.target.classList.contains("resizerY")) {
      e.preventDefault();
      const resizer = e.target;
      const t = resizer.previousElementSibling;
      const b = resizer.nextElementSibling;
      const startY = e.clientY;

      window.addEventListener("mousemove", onmousemove);
      window.addEventListener("mouseup", onmouseup);

      function onmousemove(e) {
        e.preventDefault();
        const deltaY = e.clientY - startY;
        // Resize logic based on deltaY
      }

      function onmouseup(e) {
        e.preventDefault();
        window.removeEventListener("mousemove", onmousemove);
        window.removeEventListener("mouseup", onmouseup);
      }
    }
  }
};



    // <div id="parentContainer">
    //   <div className="resizableX">
    //     <div className="resizable-item">Resizable Item 1</div>
    //     <div className="resizerX"></div>
    //     <div className="resizable-item">Resizable Item 2</div>
    //   </div>

    //   <div className="resizableX">
    //     <div className="resizable-item">Resizable Item 1</div>
    //     <div className="resizerX"></div>
    //     <div className="resizable-item">Resizable Item 2</div>
    //   </div>

    //   <div className="resizableX">
    //     <div className="resizable-item">Resizable Item 1</div>
    //     <div className="resizerX"></div>
    //     <div className="resizable-item">Resizable Item 2</div>
    //   </div>

    //   <div className="resizableX">
    //     <div className="resizable-item">Resizable Item 1</div>
    //     <div className="resizerX"></div>
    //     <div className="resizable-item">Resizable Item 2</div>
    //   </div>
    // </div>